/**
 * @file QuietEnding.jsx
 * @description The one quiet way a public page ends: a plain text line, "Questions? Contact support.",
 *   where the link opens the existing public ContactModal. Replaces the closing gradient bands that
 *   repeated the hero's buttons (founder rule: ONE call-to-action moment per page, the hero).
 *   Deliberately not a button, not a band, and not another ask to sign up.
 * @module components/QuietEnding
 */
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { T } from "../theme";
import ContactModal from "./ContactModal";

/**
 * @param {object} props
 * @param {boolean} [props.isMobile] tighter padding on phones.
 */
export default function QuietEnding({ isMobile }) {
  const { t } = useTranslation();
  const [open, setOpen] = useState(false);
  return (
    <div data-testid="quiet-ending" style={{ padding: isMobile ? "28px 18px 40px" : "36px 48px 52px", textAlign: "center", fontFamily: T.fontBody }}>
      <p style={{ margin: 0, fontSize: 14.5, color: T.textSubtle, lineHeight: 1.6 }}>
        {t("quietEnding.questions")}{" "}
        <button
          type="button"
          onClick={() => setOpen(true)}
          style={{ background: "none", border: "none", padding: 0, cursor: "pointer", color: T.indigo, fontSize: 14.5, fontWeight: 700, textDecoration: "underline", fontFamily: "inherit" }}
        >
          {t("quietEnding.contact")}
        </button>
        .
      </p>
      {open && <ContactModal onClose={() => setOpen(false)} />}
    </div>
  );
}
